var PaymentValidationStrategy = (function (_, $, PromiseUtil, PaymentStrategy) {

	var PaymentValidationStrategy = function (attrs) {
		PaymentStrategy.apply(this, arguments);

		_.extend(this, {
			Validator: null,
			Braintree: null
		}, attrs);
	};

	PaymentValidationStrategy.prototype = _.extend(window.app.jsUtils.createObjectWithProto(PaymentStrategy.prototype), {
		constructor: PaymentValidationStrategy,

		beforeProcess: function (method) {
			if (this.Validator.isValid()) {
				var validatorPromise = this.Validator.apply();
				var hostedFieldsDeferred = new $.Deferred();
				var hostedFieldsPromise = hostedFieldsDeferred.promise();

				// TBD: can it be simplified?
				var $defer = $.Deferred(),
					arguments_ = arguments;

				if ((!method || !method.Token) && this.Braintree && !this.Braintree.hostedFields.isValid()) {
					hostedFieldsDeferred.reject();
				} else {
					hostedFieldsDeferred.resolve();
				}

				$.when(validatorPromise, hostedFieldsPromise)
                    .done(function () {
					    $defer.resolve.apply($defer, arguments_);
				    });

				return $defer.promise();
			} else {
				return PromiseUtil.rejected();
			}
		},

		betweenProcessAndComplete: function () {
			if (this.Validator.isValid()) { // double check
				return PromiseUtil.resolved.apply(PromiseUtil, arguments);
			} else {
				return PromiseUtil.rejected();
			}
		}
	});

	return PaymentValidationStrategy;
})(_, $, PromiseUtil, PaymentStrategy);
